var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { AuthorizeCard, Box, BoxTruck, InStorePickup, Returns, ShipToHome, } from '@one-thd/sui-icons';
import React from 'react';
import { ERR_GENERIC_LATER } from '../../../constants/response-error-messages';
import { statusStepperData } from '../../../utils/order-history/card-utils';
var orderStatusData = function (status, dateItem) {
    if (status === void 0) { status = 'unavailable'; }
    var statusIcon = {
        'Being Processed': React.createElement(AuthorizeCard, { size: "small" }),
        arrival: React.createElement(InStorePickup, { size: "small" }),
        'On Schedule': React.createElement(BoxTruck, { size: "small" }),
        Shipped: React.createElement(BoxTruck, { size: "small" }),
        Delivered: React.createElement(ShipToHome, { size: "small" }),
        HomeDelivered: React.createElement(Box, { size: "small" }),
        Returned: React.createElement(Returns, { size: "small" }),
    }[status];
    if (status === 'unavailable')
        return null;
    var statusText;
    if (status === 'On Schedule') {
        statusText = 'Shipped';
    }
    else if (status === 'Being Processed') {
        statusText = 'Order Received';
    }
    else {
        statusText = status;
    }
    var statusUpdatedDate = dateItem === null || dateItem === void 0 ? void 0 : dateItem.statusUpdatedDate;
    var dateValue = new Date("".concat(statusUpdatedDate));
    var simplifiedDate = dateValue.toLocaleDateString('en-US', {
        timeZone: 'UTC',
        month: 'long',
        day: 'numeric',
    });
    return (React.createElement("div", { className: "sui-flex sui-gap-2 sui-items-center" },
        !['Returned', 'Canceled'].includes(status) && statusIcon,
        React.createElement(Typography, { variant: "body-base" },
            statusText,
            " ",
            simplifiedDate)));
};
export var fulfillmentStatus = function (item, view, isReturnedMultiReturn) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ((item === null || item === void 0 ? void 0 : item.fulfillmentType) === 'unavailable') {
        if (view === 'card') {
            return (React.createElement(Alert, { status: "error", size: "large" }, ERR_GENERIC_LATER.message));
        }
        if (view === 'table') {
            return (React.createElement(Alert, { status: "error", size: "large" },
                React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Order Status Unavailable"),
                ERR_GENERIC_LATER.message));
        }
    }
    if (isReturnedMultiReturn)
        return null;
    if (((_b = (_a = item === null || item === void 0 ? void 0 : item.lineItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.statusDescription) ===
        'Complete')
        return null;
    if (((_d = (_c = item === null || item === void 0 ? void 0 : item.lineItems) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.statusDescription) ===
        'Canceled' ||
        (item === null || item === void 0 ? void 0 : item.fulfillmentType) === 'BuyOnlinePickupInStore') {
        return orderStatusData(statusStepperData(((_e = item === null || item === void 0 ? void 0 : item.lineItems) === null || _e === void 0 ? void 0 : _e[0]) || null, 'statusDescription', item === null || item === void 0 ? void 0 : item.fulfillmentType), (_f = item === null || item === void 0 ? void 0 : item.lineItems) === null || _f === void 0 ? void 0 : _f[0]);
    }
    if (((_h = (_g = item === null || item === void 0 ? void 0 : item.lineItems) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.statusDescription) ===
        'Returned')
        return React.createElement(Typography, { variant: "body-base" }, "Returned");
    return null;
};
export var retrieveLineItems = function (orderData) {
    var _a;
    var lineItems = [];
    (_a = orderData === null || orderData === void 0 ? void 0 : orderData.fulfillmentGroups) === null || _a === void 0 ? void 0 : _a.forEach(function (group) {
        var _a;
        (_a = group === null || group === void 0 ? void 0 : group.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            lineItems.push(item);
        });
    });
    return lineItems;
};
export var orderNumberParams = function (order) {
    var _a, _b, _c;
    if (((_b = ((_a = order === null || order === void 0 ? void 0 : order.orderNumbers) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        return (_c = order === null || order === void 0 ? void 0 : order.orderNumbers) !== null && _c !== void 0 ? _c : [];
    }
    if (order.orderNumber) {
        return [order.orderNumber];
    }
    if (order === null || order === void 0 ? void 0 : order.receiptDetails) {
        return [order.receiptDetails];
    }
    return [];
};
export var removeReturnedStatus = function (deliveryTrackerData) {
    var modifiedData = __assign({}, deliveryTrackerData);
    if ((deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) === 'RETURNED') {
        if ((deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.deliveryType) === 'BOSS' ||
            (deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.deliveryType) === 'BOPIS') {
            modifiedData.status = 'PICKED_UP';
        }
        else {
            modifiedData.status = 'DELIVERED';
        }
    }
    return modifiedData;
};
